import React from 'react';
import Fees_Description from './Fees_Description';
import '../../../CommonCSS/SocietyCSS.css'

const Fees_DescApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Fees Description</h5>
          </div>
        </div>
        <Fees_Description />
      </div>
    </div >
  );
};

export default Fees_DescApp;
